export default __webpack_public_path__ + "static/media/img-0284-malta-premium-face.866be005.png";